/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetBadge} from '../api'

export const useMutationResetBadge = createReactQueryMutationHook('resetBadge', resetBadge)
